import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { PublicationControl } from '@/module/Author/Publication/PublicationControl';
import { PublisherSelectControl } from '@/module/Nomen/Publisher/PublisherSelectControl';
import { PublisherTypeSelectControl } from '@/module/Nomen/PublisherType/PublisherTypeSelectControl';

export interface TextControlProps {
  isSubmitting: boolean;
  showWosFields: boolean;
  showScopusFields: boolean;
}

export function TextControl(props: TextControlProps) {
  const { isSubmitting, showScopusFields, showWosFields } = props;
  const { t } = useTranslation();

  return (
    <>
      <Group align="flex-end">
        <PublisherSelectControl
          name="publisher"
          label={t('texts.form.fields.publisher')}
          isSubmitting={isSubmitting}
        />
        <PublisherTypeSelectControl
          label={t('texts.form.fields.publisherType')}
          name="publisherType"
          isSubmitting={isSubmitting}
        />
      </Group>
      <PublicationControl
        isSubmitting={isSubmitting}
        showScopusFields={showScopusFields}
        showWosFields={showWosFields}
      />
    </>
  );
}
